// extracted by mini-css-extract-plugin
export default {"container":"LoginPagePlaceholder__container___BcnYU","left":"LoginPagePlaceholder__left___Gnugv","right":"LoginPagePlaceholder__right___GaXOW"};